/*
 * @Author: your name
 * @Date: 2021-11-09 13:06:36
 * @LastEditTime: 2021-11-23 11:07:30
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \adminCRM\src\api\label.js
 */
import request from '@/utils/request';
// 统计+本地生活用户信息
export function statistics (data) {
  return request({
    url: 'order/admin/statistics',
    method: 'get',
    params: data
  });
}

// ---------跟进记录---start--------
export function remarkList (data) {
  return request({
    url: 'follow/remark/list',
    method: 'get',
    params: data
  });
}
export function remarkSave (data) {
  return request({
    url: 'follow/remark/save',
    method: 'post',
    data: data
  });
}
// ---------跟进记录---end--------

// ---------标签管理---start--------
// 用户匹配标签
export function userLabelList (data) {
  return request({
    url: 'user/tag/list',
    method: 'get',
    params: data
  });
}
// 全部标签
export function userAllList (data) {
  return request({
    url: 'user/tag/edit',
    method: 'get',
    params: data
  });
}
// 客户画像添加筛选列表
export function userFilterList (data) {
  return request({
    url: 'user/tag/filter',
    method: 'get',
    params: data
  });
}
export function addLabelSave (data) {
  return request({
    url: 'tag/add',
    method: 'post',
    data: data
  });
}
// 新增用户标签
export function addUserLabelSave (data) {
  return request({
    url: 'user/tag/add',
    method: 'post',
    data: data
  });
}

// 本地生活+拿手菜订单列表
export function orderList (data) {
  return request({
    url: 'order/list',
    method: 'post',
    data: data
  });
}
// 本地生活+拿手菜订单详情
export function orderDetail (data) {
  return request({
    url: 'order/detail',
    method: 'get',
    params: data
  });
}

export function exportUnion (file) {
  return request({
    url: 'user/tag/importExcel',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: file
  });
}

export function exportUnionSubmit (data) {
  return request({
    url: 'user/tag/importExcelSaveTag',
    method: 'post',
    headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
    data: data
  });
}
// ---------标签管理---end--------
export default {
  statistics,
  userLabelList,
  remarkList,
  remarkSave,
  addLabelSave,
  orderList,
  orderDetail,
  userFilterList,
  userAllList,
  addUserLabelSave,
  exportUnion,
  exportUnionSubmit
};



// WEBPACK FOOTER //
// ./src/api/label.js